import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SelectedFolderState {
  folderId: number | null;
  folderName: string;
  canEdit: boolean;
}

const initialState: SelectedFolderState = {
  folderId: null,
  folderName: "",
  canEdit: false,
};

const selectedFolderSlice = createSlice({
  name: 'selectedFolder',
  initialState,
  reducers: {
    setSelectedFolder(state, action: PayloadAction<{ folderId: number; folderName: string; canEdit: boolean }>) {
      state.folderId = action.payload.folderId;
      state.folderName = action.payload.folderName;
      state.canEdit = action.payload.canEdit;
    },
    clearSelectedFolder(state) {
      state.folderId = null;
      state.folderName = "";
      state.canEdit = true;
    },
  },
});

export const { setSelectedFolder, clearSelectedFolder } = selectedFolderSlice.actions;

export default selectedFolderSlice.reducer;
